import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-valuemax", "aria-valuenow"]

import { computed, onBeforeUnmount, onMounted, ref } from "vue";

const minimumHeight = 160;

export default /*@__PURE__*/_defineComponent({
  __name: 'TimelinePanel',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const panel = ref<HTMLElement>();
const availableHeight = ref(800);
const resizing = ref(false);
const maximumHeight = computed(() => Math.max(minimumHeight, availableHeight.value - 180));
const height = computed(() => clampHeight(props.modelValue));
const contentId = `dialogue-timeline-${crypto.randomUUID()}`;
let observer: ResizeObserver | undefined;
let stopResize: (() => void) | undefined;

function clampHeight(value: number) { return Math.min(maximumHeight.value, Math.max(minimumHeight, Math.round(value))); }
function nudge(delta: number) { emit("update:modelValue", clampHeight(height.value + delta)); }
function reset() { emit("update:modelValue", clampHeight(368)); }
function startResize(event: PointerEvent) {
  if (event.button !== 0) return;
  event.preventDefault();
  stopResize?.();
  const startY = event.clientY, startHeight = height.value, pointerId = event.pointerId;
  const cursor = document.body.style.cursor, userSelect = document.body.style.userSelect;
  resizing.value = true;
  document.body.style.cursor = "row-resize";
  document.body.style.userSelect = "none";
  const move = (next: PointerEvent) => {
    if (next.pointerId !== pointerId) return;
    next.preventDefault();
    emit("update:modelValue", clampHeight(startHeight + startY - next.clientY));
  };
  const end = (next: PointerEvent) => { if (next.pointerId === pointerId) cleanup(); };
  const cleanup = () => {
    window.removeEventListener("pointermove", move);
    window.removeEventListener("pointerup", end);
    window.removeEventListener("pointercancel", end);
    window.removeEventListener("blur", cleanup);
    document.body.style.cursor = cursor;
    document.body.style.userSelect = userSelect;
    resizing.value = false;
    if (stopResize === cleanup) stopResize = undefined;
  };
  stopResize = cleanup;
  window.addEventListener("pointermove", move, { passive: false });
  window.addEventListener("pointerup", end);
  window.addEventListener("pointercancel", end);
  window.addEventListener("blur", cleanup);
}
onMounted(() => {
  const host = panel.value?.parentElement;
  if (!host) return;
  const measure = () => { if (host.clientHeight) availableHeight.value = host.clientHeight; };
  measure();
  observer = new ResizeObserver(measure);
  observer.observe(host);
});
onBeforeUnmount(() => { stopResize?.(); observer?.disconnect(); });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "panel",
    ref: panel,
    class: _normalizeClass(["timeline-panel", { resizing: resizing.value }]),
    style: _normalizeStyle({ flexBasis: `${height.value}px` })
  }, [
    _createElementVNode("div", {
      class: "timeline-resize-handle",
      role: "separator",
      "aria-label": "调整 Timeline 高度",
      "aria-orientation": "horizontal",
      "aria-controls": contentId,
      "aria-valuemin": minimumHeight,
      "aria-valuemax": maximumHeight.value,
      "aria-valuenow": height.value,
      tabindex: "0",
      title: "上下拖动调整 Timeline 高度 · 双击恢复默认高度",
      onPointerdown: _withModifiers(startResize, ["stop"]),
      onDblclick: _withModifiers(reset, ["stop"]),
      onKeydown: [
        _cache[0] || (_cache[0] = _withKeys(_withModifiers(($event: any) => (nudge(16)), ["prevent"]), ["up"])),
        _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (nudge(-16)), ["prevent"]), ["down"]))
      ]
    }, [...(_cache[2] || (_cache[2] = [
      _createElementVNode("span", { "aria-hidden": "true" }, null, -1)
    ]))], 40, _hoisted_1),
    _createElementVNode("div", {
      id: contentId,
      class: "timeline-panel-content"
    }, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 6))
}
}

})